import { dsl } from '@wix/yoshi-serverless/wrap';

export const benefitsList = dsl({
          functionName: 'benefitsList',
          fileName: 'api/benefits/benefitsList.api',
        });